import {
  GET_TIME_ENTRIES_LIST,
  GET_TIME_ENTRIES_LIST_SUCCESS,
  GET_TIME_ENTRIES_LIST_FAILURE,
  TIME_ENTRY_LIST_OPEN,
  TIME_ENTRY_LIST_OPEN_SUCCESS,
  TIME_ENTRY_LIST_OPEN_FAILURE,
  TIME_ENTRY_START,
  TIME_ENTRY_START_SUCCESS,
  TIME_ENTRY_START_FAILURE,
  TIME_ENTRY_STOP,
  TIME_ENTRY_STOP_SUCCESS,
  TIME_ENTRY_STOP_FAILURE,
  TIME_ENTRY_SEARCH_BY_STAFF_ID,
  TIME_ENTRY_SEARCH_BY_STAFF_ID_SUCCESS,
  TIME_ENTRY_SEARCH_BY_STAFF_ID_FAILURE,
  GET_TIME_ENTRY_TYPE_LIST,
  GET_TIME_ENTRY_TYPE_LIST_SUCCESS,
  GET_TIME_ENTRY_TYPE_LIST_FAILURE,
  TIME_ENTRY_SINGLE_ENTRY_UPDATE,
  TIME_ENTRY_SINGLE_ENTRY_UPDATE_SUCCESS,
  TIME_ENTRY_SINGLE_ENTRY_UPDATE_FAILURE,
  TIME_ENTRY_SEARCH_WITH_TODAYS_DATE,
  TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_SUCCESS,
  TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_FAILURE,
  TIME_ENTRY_REDUX_STATE_DATA,
  TIME_ENTRY_REDUX_STATE_DATA_SUCCESS,
  TIME_ENTRY_REDUX_STATE_DATA_FAILURE,
  TIMER_IS_RUNNING,
  TIMER_IS_RUNNING_SUCCESS,
  TIMER_IS_RUNNING_FAILURE,
  TIMER_STAFF_ID,
  TIMER_STAFF_ID_SUCCESS,
  TIMER_STAFF_ID_FAILURE,
  TIMER_TIME_ENTRY_START_DATE_TIME,
  TIMER_TIME_ENTRY_START_DATE_TIME_SUCCESS,
  TIMER_TIME_ENTRY_START_DATE_TIME_FAILURE,
  TIMER_TIME_ENTRY_END_DATE_TIME,
  TIMER_TIME_ENTRY_END_DATE_TIME_SUCCESS,
  TIMER_TIME_ENTRY_END_DATE_TIME_FAILURE,
  TIMER_JOB_ID,
  TIMER_JOB_ID_SUCCESS,
  TIMER_JOB_ID_FAILURE,
  TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID,
  TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID_SUCCESS,
  TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID_FAILURE,
  TIMER_BILLABLE_TYPE,
  TIMER_BILLABLE_TYPE_SUCCESS,
  TIMER_BILLABLE_TYPE_FAILURE,
  TIMER_NOTES,
  TIMER_NOTES_SUCCESS,
  TIMER_NOTES_FAILURE,
  TIME_ACTIVE_TAB,
  TIME_ACTIVE_TAB_SUCCESS,
  TIME_ACTIVE_TAB_FAILURE,
  PAUSE_TIMER,
  PAUSE_TIMER_SUCCESS,
  PAUSE_TIMER_FAILURE,
  ADD_PRODUCT_ID,
  ADD_PRODUCT_ID_SUCCESS,
  ADD_PRODUCT_ID_FAILURE,
  ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE,
  ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS,
  ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE,
  DELETE_TIME_ENTRY_NON_BILLABLE_TYPE,
  DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS,
  DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE,
  UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE,
  UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS,
  UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE,
  DELETE_SELECTED_TIME_ENTRIES,
  DELETE_SELECTED_TIME_ENTRIES_SUCCESS,
  DELETE_SELECTED_TIME_ENTRIES_FAILURE,
  ACTION_EVENT_FIRED,
  ACTION_EVENT_FIRED_SUCCESS,
  ACTION_EVENT_FIRED_FAILURE,
  TIME_ENTRY_LIST_SUMMARY_DAILY,
  TIME_ENTRY_LIST_SUMMARY_DAILY_SUCCESS,
  TIME_ENTRY_LIST_SUMMARY_DAILY_FAILURE,
  TIME_ENTRY_CREATE,
  TIME_ENTRY_CREATE_SUCCESS,
  TIME_ENTRY_CREATE_FAILURE,
  TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY,
  TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_SUCCESS,
  TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_FAILURE,
} from "./actionType";

// reducer function
const localConfig_14X = JSON.parse(localStorage.getItem("authUser"))
  ?.get_configitem_data?.ZCONFIGVAL_14_X;

const initialState = {
  timeEntries: [],
  timeEntriesLoading: false,
  timeEntry: {},
  timeEntryStopSuccess: [],
  error: null,
  loading: false,
  timeEntryTypes: [],
  timeEntryListOpenLive: [],
  timeEntryData: {
    timeentry_data: {
      Staff_Id: "",
      TimeEntryStartDateTime: "today",
      TimeEntryEndDateTime: "",
      Job_Id: "",
      Job_Title: "",
      Customer_FullName: "",
      Task_Id: "",
      BillableType: "1",
      TimeEntryTypeUnbillable_Id: "",
      Notes: "",
      timerIsRunning: false,
      pauseTimer: false,
      activeTab: "1",
      timerStartTimerLoading: false,
      timeEntryStartSuccess: [],
      Product_Id: localConfig_14X ? localConfig_14X : "",
    },
  },
  timeEntryUpdate: [],
  timeEntryUpdateLoading: false,
  addNewNonBillableTypeSuccess: [],
  deleteNonBillableTypeSuccess: [],
  updateNonBillableTypeSuccess: [],
  deleteSelectedTimeEntriesSuccess: [],
  actionEventFired: false,

  //TIME_ENTRY_LIST_SUMMARY_DAILY
  timeEntryListSummaryDaily: [],
  timeEntryListSummaryDailyLoading: false,
  timeEntryListSummaryDailyError: null,

  //TIME_ENTRY_CREATE
  timeEntryCreateSuccess: [],
  timeEntryCreateFailure: [],
  timeEntryCreateLoading: false,

  //TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY
  timeEntryListSummaryDailyByActivity: [],
  timeEntryListSummaryDailyByActivityLoading: false,
  timeEntryListSummaryDailyByActivityError: null,
};

const TimeEntries = (state = initialState, action) => {
  switch (action.type) {
    case GET_TIME_ENTRIES_LIST:
      return {
        ...state,
        timeEntriesLoading: true,
      };
    case GET_TIME_ENTRIES_LIST_SUCCESS:
      return {
        ...state,
        timeEntries: action.payload,
        timeEntriesLoading: false,
      };
    case GET_TIME_ENTRIES_LIST_FAILURE:
      return {
        ...state,
        timeEntriesLoading: false,
        error: action.payload,
      };
    case TIME_ENTRY_LIST_OPEN:
      return {
        ...state,
        timeEntryListOpenLive: action.payload,
        loading: true,
      };
    case TIME_ENTRY_LIST_OPEN_SUCCESS:
      return {
        ...state,
        timeEntryListOpenLive: action.payload,
        loading: false,
      };
    case TIME_ENTRY_LIST_OPEN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case TIME_ENTRY_START:
      return {
        ...state,
        timerStartTimerLoading: true,
      };
    case TIME_ENTRY_START_SUCCESS:
      return {
        ...state,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            timeEntryStartSuccess: action.payload,
          },
        },
        timerStartTimerLoading: false,
      };
    case TIME_ENTRY_START_FAILURE:
      return {
        ...state,
        timerStartTimerLoading: false,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            timeEntryStartSuccess: action.payload,
          },
        },
      };
    case TIME_ENTRY_STOP:
      return {
        ...state,
        timeEntry: action.payload,
        loading: true,
      };
    case TIME_ENTRY_STOP_SUCCESS:
      return {
        ...state,
        timeEntryStopSuccess: action.payload,
        loading: false,
      };
    case TIME_ENTRY_STOP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case TIME_ENTRY_SEARCH_BY_STAFF_ID:
      return {
        ...state,
        staff_id: action.payload,
        loading: true,
      };
    case TIME_ENTRY_SEARCH_BY_STAFF_ID_SUCCESS:
      return {
        ...state,
        timeEntries: action.payload,
        loading: false,
      };
    case TIME_ENTRY_SEARCH_BY_STAFF_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_TIME_ENTRY_TYPE_LIST:
      return {
        ...state,
        loading: true,
      };
    case GET_TIME_ENTRY_TYPE_LIST_SUCCESS:
      return {
        ...state,
        timeEntryTypes: action.payload,
      };
    case GET_TIME_ENTRY_TYPE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case TIME_ENTRY_SINGLE_ENTRY_UPDATE:
      return {
        ...state,
        timeEntryUpdate: action.payload,
        timeEntryUpdateLoading: true,
      };
    case TIME_ENTRY_SINGLE_ENTRY_UPDATE_SUCCESS:
      return {
        ...state,
        timeEntryUpdate: action.payload,
        timeEntryUpdateLoading: false,
      };
    case TIME_ENTRY_SINGLE_ENTRY_UPDATE_FAILURE:
      return {
        ...state,
        timeEntryUpdateLoading: false,
        timeEntryUpdate: action.payload,
      };
    case TIME_ENTRY_SEARCH_WITH_TODAYS_DATE:
      return {
        ...state,
        sendTimeEntrySearchTodaysDate: action.payload,
        loading: true,
      };
    case TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_SUCCESS:
      return {
        ...state,
        timeEntrySearchTodaysDate: action.payload,
        loading: false,
      };
    case TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case TIME_ENTRY_REDUX_STATE_DATA:
      return {
        ...state,
        // timeEntryData: action.payload,
        loading: true,
      };
    case TIME_ENTRY_REDUX_STATE_DATA_SUCCESS:
      return {
        ...state,
        timeEntryData: action.payload,
      };
    case TIME_ENTRY_REDUX_STATE_DATA_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case TIMER_IS_RUNNING:
      return {
        ...state,
        loading: true,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            timerIsRunning: action.payload,
          },
        },
      };
    case TIMER_IS_RUNNING_SUCCESS:
      return {
        ...state,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            timerIsRunning: action.payload,
          },
        },
      };
    case TIMER_IS_RUNNING_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case TIMER_STAFF_ID:
      return {
        ...state,
        loading: true,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            Staff_Id: action.payload,
          },
        },
      };
    case TIMER_STAFF_ID_SUCCESS:
      return {
        ...state,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            Staff_Id: action.payload,
          },
        },
      };
    case TIMER_STAFF_ID_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case TIMER_TIME_ENTRY_START_DATE_TIME:
      return {
        ...state,
        loading: true,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            TimeEntryStartDateTime: action.payload,
          },
        },
      };
    case TIMER_TIME_ENTRY_START_DATE_TIME_SUCCESS:
      return {
        ...state,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            TimeEntryStartDateTime: action.payload,
          },
        },
      };
    case TIMER_TIME_ENTRY_START_DATE_TIME_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case TIMER_TIME_ENTRY_END_DATE_TIME:
      return {
        ...state,
        loading: true,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            TimeEntryEndDateTime: action.payload,
          },
        },
      };
    case TIMER_TIME_ENTRY_END_DATE_TIME_SUCCESS:
      return {
        ...state,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            TimeEntryEndDateTime: action.payload,
          },
        },
      };
    case TIMER_TIME_ENTRY_END_DATE_TIME_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case TIMER_JOB_ID:
      return {
        ...state,
        loading: true,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            Job_Id: action.payload,
          },
        },
      };
    case TIMER_JOB_ID_SUCCESS:
      return {
        ...state,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            Job_Id: action.payload,
          },
        },
      };
    case TIMER_JOB_ID_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID:
      return {
        ...state,
        loading: true,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            TimeEntryTypeUnbillable_Id: action.payload,
          },
        },
      };
    case TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID_SUCCESS:
      return {
        ...state,
        timeEntry: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            TimeEntryTypeUnbillable_Id: action.payload,
          },
        },
      };
    case TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case TIMER_BILLABLE_TYPE:
      return {
        ...state,
        loading: true,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            BillableType: action.payload,
          },
        },
      };
    case TIMER_BILLABLE_TYPE_SUCCESS:
      return {
        ...state,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
          },
        },
      };
    case TIMER_BILLABLE_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case TIMER_NOTES:
      return {
        ...state,
        loading: true,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            Notes: action.payload,
          },
        },
      };
    case TIMER_NOTES_SUCCESS:
      return {
        ...state,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            Notes: action.payload,
          },
        },
      };
    case TIMER_NOTES_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case TIME_ACTIVE_TAB:
      return {
        ...state,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            activeTab: action.payload,
          },
        },
      };
    case PAUSE_TIMER:
      return {
        ...state,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            pauseTimer: action.payload,
          },
        },
      };
    case PAUSE_TIMER_SUCCESS:
      return {
        ...state,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            pauseTimer: action.payload,
          },
        },
      };
    case PAUSE_TIMER_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ADD_PRODUCT_ID:
      return {
        ...state,
        loading: true,
      };
    case ADD_PRODUCT_ID_SUCCESS:
      return {
        ...state,
        timeEntryData: {
          timeentry_data: {
            ...state.timeEntryData.timeentry_data,
            Product_Id: action.payload,
          },
        },
        loading: false,
      };
    case ADD_PRODUCT_ID_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE:
      return {
        ...state,
      };
    case ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS:
      return {
        ...state,
        addNewNonBillableTypeSuccess: action.payload,
      };
    case ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE:
      return {
        ...state,
        addNewNonBillableTypeSuccess: action.payload,
      };
    case DELETE_TIME_ENTRY_NON_BILLABLE_TYPE:
      return {
        ...state,
      };
    case DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS:
      return {
        ...state,
        deleteNonBillableTypeSuccess: action.payload,
      };
    case DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE:
      return {
        ...state,
        deleteNonBillableTypeSuccess: action.payload,
      };
    case UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE:
      return {
        ...state,
      };
    case UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS:
      return {
        ...state,
        updateNonBillableTypeSuccess: action.payload,
      };
    case UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE:
      return {
        ...state,
        updateNonBillableTypeSuccess: action.payload,
      };
    case DELETE_SELECTED_TIME_ENTRIES:
      return { ...state };
    case DELETE_SELECTED_TIME_ENTRIES_SUCCESS:
      return { ...state, deleteSelectedTimeEntriesSuccess: action.payload };
    case DELETE_SELECTED_TIME_ENTRIES_FAILURE:
      return { ...state, deleteSelectedTimeEntriesSuccess: action.payload };

    case ACTION_EVENT_FIRED:
      return { ...state };
    case ACTION_EVENT_FIRED_SUCCESS:
      return { ...state, actionEventFired: action.payload };
    case ACTION_EVENT_FIRED_FAILURE:
      return { ...state, actionEventFired: action.payload };
    //TIME_ENTRY_LIST_SUMMARY_DAILY
    case TIME_ENTRY_LIST_SUMMARY_DAILY:
      return {
        ...state,
        timeEntryListSummaryDailyLoading: true,
      };
    case TIME_ENTRY_LIST_SUMMARY_DAILY_SUCCESS:
      return {
        ...state,
        timeEntryListSummaryDaily: action.payload,
        timeEntryListSummaryDailyLoading: false,
      };
    case TIME_ENTRY_LIST_SUMMARY_DAILY_FAILURE:
      return {
        ...state,
        timeEntryListSummaryDailyLoading: false,
        timeEntryListSummaryDailyError: action.payload,
      };
    //TIME_ENTRY_CREATE
    case TIME_ENTRY_CREATE:
      return {
        ...state,
        timeEntryCreateLoading: true,
      };
    case TIME_ENTRY_CREATE_SUCCESS:
      return {
        ...state,
        timeEntryCreateSuccess: action.payload,
        timeEntryCreateLoading: false,
      };
    case TIME_ENTRY_CREATE_FAILURE:
      return {
        ...state,
        timeEntryCreateFailure: action.payload,
        timeEntryCreateLoading: false,
      };

    //TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY
    case TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY:
      return {
        ...state,
        timeEntryListSummaryDailyByActivityLoading: true,
      };
    case TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_SUCCESS:
      return {
        ...state,
        timeEntryListSummaryDailyByActivity: action.payload,
        timeEntryListSummaryDailyByActivityLoading: false,
      };
    case TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_FAILURE:
      return {
        ...state,
        timeEntryListSummaryDailyByActivityLoading: false,
        timeEntryListSummaryDailyByActivityError: action.payload,
      };

    default:
      return state;
  }
};

export default TimeEntries;
